// Post statuses
export const POST_STATUS = {
  PENDING: 'pending',
  NEEDS_CHANGES: 'needs_changes',
  APPROVED: 'approved',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published',
};

// Status display config
export const STATUS_CONFIG = {
  [POST_STATUS.PENDING]: {
    label: 'Pending Approval',
    color: 'yellow',
    bgClass: 'bg-yellow-100',
    textClass: 'text-yellow-800',
    badgeClass: 'badge-pending',
  },
  [POST_STATUS.NEEDS_CHANGES]: {
    label: 'Needs Changes',
    color: 'red',
    bgClass: 'bg-red-100',
    textClass: 'text-red-800',
    badgeClass: 'badge-needs-changes',
  },
  [POST_STATUS.APPROVED]: {
    label: 'Approved',
    color: 'green',
    bgClass: 'bg-green-100',
    textClass: 'text-green-800',
    badgeClass: 'badge-approved',
  },
  [POST_STATUS.SCHEDULED]: {
    label: 'Scheduled',
    color: 'blue',
    bgClass: 'bg-blue-100',
    textClass: 'text-blue-800',
    badgeClass: 'badge-scheduled',
  },
  [POST_STATUS.PUBLISHED]: {
    label: 'Published',
    color: 'emerald',
    bgClass: 'bg-emerald-100',
    textClass: 'text-emerald-800',
    badgeClass: 'badge-published',
  },
};

// User roles
export const USER_ROLES = {
  ADMIN: 'agency_admin', // Changed from 'admin' to match database
  AGENCY_ADMIN: 'agency_admin',
  DESIGNER: 'designer',
  WRITER: 'writer',
  CLIENT: 'client',
  SUPER_ADMIN: 'super_admin',
  SEO_SPECIALIST: 'seo_specialist',
};

// Role display names
export const ROLE_NAMES = {
  [USER_ROLES.ADMIN]: 'Agency Admin',
  [USER_ROLES.AGENCY_ADMIN]: 'Agency Admin',
  [USER_ROLES.DESIGNER]: 'Designer',
  [USER_ROLES.WRITER]: 'Content Writer',
  [USER_ROLES.CLIENT]: 'Client',
  [USER_ROLES.SUPER_ADMIN]: 'Super Admin',
  [USER_ROLES.SEO_SPECIALIST]: 'SEO Specialist',
};

// Notification types
export const NOTIFICATION_TYPES = {
  COMMENT: 'comment',
  STATUS_CHANGE: 'status_change',
  MENTION: 'mention',
  APPROVAL: 'approval',
  NEW_POST: 'new_post',
  NEW_VERSION: 'new_version',
};

// API base URL
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

// File upload config
export const UPLOAD_CONFIG = {
  MAX_SIZE: 100 * 1024 * 1024, // 100MB (for videos)
  MAX_IMAGE_SIZE: 5 * 1024 * 1024, // 5MB for images
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_VIDEO_TYPES: ['video/mp4', 'video/mpeg', 'video/quicktime'], // MP4, MPEG, MOV
  ALLOWED_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'video/mp4', 'video/mpeg', 'video/quicktime'],
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.mp4', '.mov', '.mpeg'],
};

// Date format
export const DATE_FORMAT = 'MMM DD, YYYY';
export const DATETIME_FORMAT = 'MMM DD, YYYY h:mm A';


